import { render, staticRenderFns } from "./myfoot.vue?vue&type=template&id=a5f70506&scoped=true&"
import script from "./myfoot.vue?vue&type=script&lang=js&"
export * from "./myfoot.vue?vue&type=script&lang=js&"
import style0 from "./myfoot.vue?vue&type=style&index=0&id=a5f70506&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f70506",
  null
  
)

export default component.exports